import { render, staticRenderFns } from "./roleOrgForm.vue?vue&type=template&id=46b7a7e8&"
import script from "./roleOrgForm.vue?vue&type=script&lang=js&"
export * from "./roleOrgForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports